import { AllItemDamageReasonsResponse, DamageReasonResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { DamagereasonRequest } from './dto/item-damage-reason.request';
import { DamageReasonDto } from './dto/item-damage-reasons.dto';
import { ItemDamageReasonsService } from './item-damage-reasons.service';

@Controller('item-damage-reasons')
@ApiTags('item-damage-reasons')
export class ItemDamageReasonsController {
    constructor(
        private damageReasonService: ItemDamageReasonsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates  a Item damageReason
     * @param ItemdamageReason Item damageReason DTO
     * @returns Item damageReasonResponse
     */
    @Post('/createItemDamageReason')
    async createItemDamageReason(@Body() damageReasondto:DamageReasonDto,isUpdate:boolean=false,@Req() request:Request): Promise<DamageReasonResponse> {
        try {
         return await this.damageReasonService.createItemDamageReason(damageReasondto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(DamageReasonResponse, error);
       }
     }

      /**
     * gets all the Value Item daage reasons
     * @returns AllItemDamageReasonsResponseModel which returns all the Value Item daage reasons  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllItemDamageReasons')
    async getAllItemDamageReasons(): Promise<AllItemDamageReasonsResponse> {
        try {
            return await this.damageReasonService.getAllItemDamageReasons();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllItemDamageReasonsResponse, error);
        }
    }

     /**
     * Activate Or De-Activate Value Item damage Reason
     * @param getSingleItemDamageReason Item damage Reason 
     * @returns Value itemdamagereasonResponse
     */
   @Post('/activateOrDeactivateItemdamageReason')
   async activateOrDeactivateItemdamageReason(@Body() damReq: DamagereasonRequest): Promise<DamageReasonResponse> {
       try {
           return await this.damageReasonService.activateOrDeactivateItemdamageReason(damReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(DamageReasonResponse, err);
       }
   }

   /**
     *  updates a  value damage Reason
     * @param damageReason damageReason DTO
     * @returns DamageReasonResponse
     */
    @Post('/updateItemdamageReason')
    async updateItemdamageReason(@Body() damageReasondto:DamageReasonDto,isUpdate:boolean=true,@Req() request:Request): Promise<DamageReasonResponse> {
        try {
         return await this.damageReasonService.createItemDamageReason(damageReasondto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(DamageReasonResponse, error);
       }
     }
}
